// extracted by mini-css-extract-plugin
export default {"links":"Comparison_links__kgBF+","dashboard":"Comparison_dashboard__3y5-3","carousel":"Comparison_carousel__w3CAv","slide":"Comparison_slide__yqmYT","grid":"Comparison_grid__9pI4f"};